module.exports = __webpack_public_path__ + "media/ninnaji.7baaed6b.mp4";